module.exports = __webpack_public_path__ + "static/e-why-choose-shipkoo-04b6ebce0665f524c1167cacd9ec1bc8.png";